exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ContactFormView form {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-gap: 10px;\n}\n.ContactFormView form .textArea {\n  grid-column-start: 1;\n  grid-column-end: 3;\n}\n.ContactFormView form button {\n  grid-column-start: 2;\n  justify-self: end;\n}\n", ""]);

// exports
